import { getUrlParameter } from '../../fdpq-widget/utils/helperUtil';

/**
 * Derives the safe targetOrigin for postMessage to the parent window.
 *
 * The widget is embedded by multiple parent apps (kbb.com, drr-slp, etc.).
 * Each parent injects an `origin` URL param when constructing the iframe src,
 * e.g. `&origin=https://www.kbb.com/free-dealer-price-quote/`.
 *
 * Priority order:
 *   1. `origin` URL param (set by the parent page) — multi-domain safe.
 *   2. `'*'` if the parent passed `origin=*` explicitly.
 *   3. `document.referrer` — but ONLY if its origin differs from the iframe's
 *      own origin. Otherwise it reflects internal SPA navigation within the
 *      widget (e.g. `https://fdpq.syndication.kbb.com`) and would cause a
 *      cross-origin postMessage failure against the real parent (`www.kbb.com`).
 *   4. `'*'` as a last resort so analytics still fire.
 */
const getParentOrigin = () => {
  try {
    const originParam = getUrlParameter('origin');
    if (originParam === '*') {
      return '*';
    }
    if (originParam) {
      return new URL(originParam).origin;
    }
  } catch (e) {
    console.warn('[FDPQ Analytics Trace] getParentOrigin: failed to parse origin param', e);
  }
  try {
    if (document.referrer) {
      const referrerOrigin = new URL(document.referrer).origin;
      // Same-origin referrer means internal SPA navigation, not the real parent.
      if (referrerOrigin !== window.location.origin) {
        return referrerOrigin;
      }
    }
  } catch (e) {
    console.warn('[FDPQ Analytics Trace] getParentOrigin: failed to parse document.referrer', e);
  }
  return '*';
};

export const sendEventPixall = (guid, eventData, vehicleData) => {
    const contentEvent = {
      pxamMessageType: 'pxamContentEvent',
      eventType: eventData?.eventType,
      formEventId: guid,
      eventSource: eventData?.eventSource,
      eventFields: {
        ...eventData?.eventFields,
        feature: eventData?.feature,
        label: eventData?.label,
        assistChannel: eventData?.assistChannel,
        assistProduct: eventData?.assistProduct,
        assistSubchannel: eventData?.assistSubchannel,
        pageId: eventData?.pageId,
        pageType: eventData?.pageType,
        cdl: {
            event: {
              action: eventData?.eventType,
              element: eventData?.eventFields?.element,
              assistChannel: eventData?.assistChannel,
              assistProduct: eventData?.assistProduct,
              assistSubChannel: eventData?.assistSubchannel,
              tagIndex: eventData?.eventFields?.tagIndex,
              valueEventCode: vehicleData?.valueEventCode,
            },
            vehicle: {
              bodyStyleGroup: vehicleData?.bodyStyle || '',
              driveTrain: vehicleData?.driveTrain || '',
              fuelType: vehicleData?.fuelType || '',
              descriptionExists: vehicleData?.descriptionExists || 'no',
              legacyConfigurationId: vehicleData?.legacyConfigurationId || '',
              productConfiguration: vehicleData?.productConfiguration || '',
              seriesId: vehicleData?.seriesId || '',
              subCategory: vehicleData?.subCategory || '',
              sellerType: vehicleData?.sellerType ||'dealer',
              transmission: vehicleData?.transmission || '',
              trimId: vehicleData?.chromeStyleId || '',
            },
            eventProperties: {
              event: {
                valueEventCode: vehicleData?.valueEventCode,
              }
            },
        },
        ...vehicleData,
      }, 
    };

    let url = getParentOrigin();
    var parentWindow = window.opener || top;
    parentWindow.postMessage(JSON.stringify(contentEvent), url);
}

/**
 * Create CoxAuto Correlation Id
 */
export const createCoxAutoCorrelationId = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
};
  
  